(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').directive('paymentMethodDetails', ['commonService', '$http', 'uteEndpoint', '$rootScope',  function ( commonService, $http, uteEndpoint, $rootScope) {
    return {
      restrict: 'EA',
      scope: {
        selectedAccountDetails: '=',
      },
      templateUrl: 'modules/my-account/views/payment-method/payment-info.html',
      link: function ($scope, $element, $attr) {

      },
      controller: ['$scope', '$rootScope', function($scope, $rootScope){
        var self = this;
        self.isCCExpired = false;
        self.isCCExpiring = false;
        $scope.showCreditCardPayment = false;
        $scope.showChequingPayment = false;
        $scope.showInvoicePayment = false;
        $scope.paymentMethodUnavailable = false;
        $scope.currentPaymentMethodData = '';
        $scope.chequingAccountNumber = '';
        $scope.creditCardDetail = {};
        //$scope.disablePaynowButton = true;
        var paymentMethod = {
          credit :  'C',
          chequing: 'D',
          invoice: 'R'
        };
        var selectedAccountDetail = '';
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { //mobile browser
          $scope.isMobileDevice = true;
        }
        console.log('$rootScope.payNowButton value'+ $rootScope.payNowButton);
        if($rootScope.payNowButton && $rootScope.payNowButton === 'disablePayNowButton'){
          console.log('disabling paynow button');
          $scope.disablePaynowButton = true;
        }
        else if($rootScope.payNowButton && $rootScope.payNowButton === 'enablePayNowButton') {
          console.log('enabling paynow button');
          $scope.disablePaynowButton = false;
        }
        $scope.fetchBankAccountNumber = function() {
          var accountNumber = _.get($scope.currentPaymentMethodData, 'chequingDetails.accountNumber', '');
          return accountNumber.slice(0, 1) + 'XXXXX-XXX' + accountNumber.slice(1);
        };

        $scope.fetchCreditCardDetails = function() {
          if ($scope.currentPaymentMethodData.moptype === paymentMethod.credit) {
            var ccExpiry = _.get($scope.currentPaymentMethodData, 'creditCardDetails.ccExpiry', '');
            return {
              number: '**** **** **** ' + _.get($scope.currentPaymentMethodData, 'creditCardDetails.ccNumber', '    '),
              expiry: ccExpiry.slice(0, 2) + '/' + (new Date()).getFullYear().toString().slice(0, 2) + ccExpiry.slice(2),
              type: _.get($scope.currentPaymentMethodData, 'creditCardDetails.ccType')
            };
          }
        };

        self.compareDate = function(currDate, expDate) {
          return currDate.getMonth() - expDate.getMonth() + (12 * (currDate.getFullYear() - expDate.getFullYear()));
        };

        $scope.checkCCDateValidity = function(){
          this.isCCExpired = false;
          this.isCCExpiring = false;
          var ccExpiry = _.get($scope.currentPaymentMethodData, 'creditCardDetails.ccExpiry', '    ');
          var ccExpiryYear = (new Date()).getFullYear().toString().slice(0, 2) + ccExpiry.slice(2, 4);
          var ccExpiryMonth = ccExpiry.slice(0, 2);
          var expiryDate = new Date(+ccExpiryYear, (+ccExpiryMonth - 1), 1);
          var currentDate = new Date((new Date()).getFullYear(), (new Date).getMonth(), 1);
          var cmpDate = self.compareDate(currentDate, expiryDate);
          if (cmpDate === 0 || cmpDate === -1) {
            this.isCCExpiring = true;
          } else if (cmpDate > 0) {
            this.isCCExpired = true;
          }
        };

        $scope.calculateDaysToExpire = function() {
          var todayDate = new Date();
          var expDate = $scope.retrieveExpiryDate();
          var days = expDate - todayDate;
          return Math.round(days / (1000 * 60 * 60 * 24));
        };

        $scope.retrieveExpiryDate = function(){
          var expArr = $scope.creditCardDetail.expiry.split('/');
          return new Date(parseInt(expArr[1]), parseInt(expArr[0]), 0);
        };

        self.formatPaymentMethod = function(){
          if($scope.currentPaymentMethodData.moptype == paymentMethod.credit){
            $scope.creditCardDetail = $scope.fetchCreditCardDetails();
            $scope.showCreditCardPayment = true;
            if($scope.creditCardDetail.type === 'VISA') {
              $scope.cardTypeSrc = '/html-fido/cms/ute/fido/images/visa-icon-1217.png';
              $scope.cardType = 'visa-card';
            }
            if($scope.creditCardDetail.type == 'AMEX') {
              $scope.cardTypeSrc = '/html-fido/cms/ute/fido/images/amex-icon.png';
              $scope.cardType = 'amex-card';
            }
            if ($scope.creditCardDetail.type == 'MASTER') {
              $scope.cardTypeSrc = '/html-fido/cms/ute/fido/images/mc.png';
              $scope.cardType = 'mc-card';
            }
            $scope.checkCCDateValidity();
          }else if($scope.currentPaymentMethodData.moptype == paymentMethod.chequing){
            $scope.chequingAccountNumber = $scope.fetchBankAccountNumber();
            $scope.showChequingPayment = true;
          }else if($scope.currentPaymentMethodData.moptype == paymentMethod.invoice){
            $scope.showInvoicePayment = true;
          }else{
            $scope.paymentMethodUnavailable = true;
          }
        };

        $scope.getLastDigits = function(number, type){
          var num = !_.isEmpty(number) ? number : '' ;
          if(angular.isDefined(number) && number.length > 4){
            if(type == paymentMethod.credit){ //retrieve last 4 digits
              num =  number.slice(-4);
            }else{
              num =  number.slice(0,1) + number.slice(-3); //retrieve first & last 3 digits
            }
          }
          return num;
        };

        $scope.accountStatus = function (accountNumber) {
          var currentAccount = _.find($rootScope.userInfo.accounts, function (account) {
            return account.accountNumber === accountNumber;
          });
          if (currentAccount && currentAccount.status) {
            return currentAccount.status.toUpperCase();
          } else {
            return '';
          }
        };

        $scope.init = function(){
          $scope.showLoader = false;
          selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
            return accountDetail.accountNumber === $scope.selectedAccountDetails.accountNumber;
          });
          $scope.hasOutstandingBalance = Number(selectedAccountDetail.balance) > 0;
          $scope.selectedAccountStatus = $scope.accountStatus(selectedAccountDetail.accountNumber);
          $scope.accountNumber = $scope.selectedAccountDetails.accountNumber;
          if($scope.selectedAccountDetails && $scope.selectedAccountDetails.LOB != 'WLPP' && self.selectedAccountStatus != 'CANCELLED'){
            if($scope.selectedAccountDetails && $scope.selectedAccountDetails.methodOfPaymentDetails && !_.isEmpty($scope.selectedAccountDetails.methodOfPaymentDetails) && $scope.selectedAccountDetails.hasWireless){
              $scope.currentPaymentMethodData = $scope.selectedAccountDetails.methodOfPaymentDetails;
              self.formatPaymentMethod();
            }else if($scope.selectedAccountDetails.hasInternet){
              $scope.showLoader = true;
              $http({
                method: 'POST',
                url: uteEndpoint('v1/billingArrangementData'),
                data: {
                  billingArrangementId: $scope.selectedAccountDetails.accountNumber
                }
              }).success(function (data) {
                if(data && !data.error){
                  selectedAccountDetail.MOPType = data.methodOfPayment;
                  selectedAccountDetail.methodOfPaymentDetails = {};
                  if(data.methodOfPayment == 'pacc'){
                  $scope.internetMop = true;
                    if(data.creditCardInfo) {
                      selectedAccountDetail.methodOfPaymentDetails.creditCardDetails = {
                        ccNumber: $scope.getLastDigits(data.creditCardInfo.ccNumber, paymentMethod.credit),
                        ccExpiry: (data.creditCardInfo.ccExpiryMonth && data.creditCardInfo.ccExpiryYear) ? data.creditCardInfo.ccExpiryMonth + data.creditCardInfo.ccExpiryYear : '',
                        ccType: data.creditCardInfo.ccType
                      }
                    }
                    selectedAccountDetail.methodOfPaymentDetails.moptype = paymentMethod.credit ;
                  }else if(data.methodOfPayment == 'pac'){
                    if(data.bankDetails) {
                      selectedAccountDetail.methodOfPaymentDetails.chequingDetails = {
                        accountNumber: $scope.getLastDigits(data.bankDetails.bankAccountNo, paymentMethod.chequing),
                        bankNumber: data.bankDetails.bankCode,
                        transitNumber: data.bankDetails.bankBranchNo
                      }
                    }
                    selectedAccountDetail.methodOfPaymentDetails.moptype = paymentMethod.chequing ;
                  }else if(data.methodOfPayment == 'invoice'){
                    selectedAccountDetail.methodOfPaymentDetails.moptype = paymentMethod.invoice ;
                  }
                  $scope.currentPaymentMethodData = selectedAccountDetail.methodOfPaymentDetails;
                  self.formatPaymentMethod();
                  $scope.showLoader = false;
                }else{
                  $scope.showLoader = false;
                  $scope.paymentMethodUnavailable = true;
                }
              }).error(function(){
                $scope.showLoader = false;
                $scope.paymentMethodUnavailable = true;
              });
            }else{
              $scope.paymentMethodUnavailable = true;
            }
          }
        };
        $scope.init();

        $scope.showPaymentMethodSection = function() {
          if ($scope.selectedAccountDetails && $scope.selectedAccountDetails.LOB != 'WLPP' && ($scope.selectedAccountStatus !== 'SUSPENDED' && $scope.selectedAccountStatus !== 'CANCELLED')) {
            return true;
          }
          return false;
        }
      }]
    };

  }]);

})();
